import ConnectWalletModal from './ConnectWalletModal';
import ErrorModal from './Status/ErrorModal';
import SuccessModal from './Status/SuccessModal';
import WaitingModal from './Status/WaitingModal';
import WarningModal from './Status/WarningModal';
import ShareOpenPositionModal from './Share/ShareOpenPositionModal';
import ShareClosedPositionModal from './Share/ShareClosedPositionModal';
import SharePnlRankingModal from './Share/SharePnlRankingModal';
import DemoDisclaimerModal from './Status/DemoDisclaimerModal';
import { memo } from 'react';

const ModalsContainer = memo(() => (
    <>
        <ErrorModal />
        <WarningModal />
        <SuccessModal />
        <WaitingModal />
        <ConnectWalletModal />
        <SharePnlRankingModal />
        <ShareOpenPositionModal />
        <ShareClosedPositionModal />
        <DemoDisclaimerModal />
    </>
));

export default ModalsContainer;
